export enum ApplicationEnvironment {
	LOCAL = 'local',
	PROD = 'prod',
	DEV = 'dev',
	RC = 'rc',
}
